import { NeuCard } from '@neutron/react';
import styled from 'styled-components';

export const ComplianceMetricContainer = styled(NeuCard)`
  width: 200px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  padding: 1rem 1.75rem 0 0;
  margin-top: 1rem;
  overflow: clip;
  :hover {
    cursor: pointer;
  }
`;

export const TaskMetricContainer = styled(NeuCard)`
  margin: 0.5rem;
  height: 100%;
  padding-left: 1rem;
  padding-bottom: 1rem;
  :hover {
    cursor: pointer;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-top: 0.25rem;
`;

export const TitleContainer = styled.div`
  font-weight: 700;
  font-size: 18px;
`;
